module.exports = __webpack_public_path__ + "static/chart-lean.7041f8d5.svg";